import React from 'react';
import Paper from '@mui/material/Paper/Paper';
import Table from '@mui/material/Table/Table';
import TableContainer from '@mui/material/TableContainer/TableContainer';
import { useBackdropContext } from '../../../../../../context/backdrop';
import { useHorizontalScroll } from '../../../../../../modules/store/hooks/use-scroll';

type TablePriceProps = {
  children: React.ReactNode[];
};

export const TablePrice: React.FC<TablePriceProps> = ({ children }) => {
  const { preventCarouselSwipe, unblockCarouselSwipe } = useBackdropContext();
  const { scrollableRef } = useHorizontalScroll<HTMLDivElement>();

  const preventScroll = () => preventCarouselSwipe(true);

  return (
    <TableContainer ref={scrollableRef} component={Paper}>
      <Table sx={{ minWidth: 300 }} size="small" onTouchStart={preventScroll} onTouchEnd={unblockCarouselSwipe}>
        {children}
      </Table>
    </TableContainer>
  );
};
